/**
 * 模块名称: 供应商管理 => 金蝶供应商关联关系
 * @author zhuyan@372163.com
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Table,
  Form,
  Alert,
  Button,
  Input,
  message,
  Modal,
  Select,
  Popconfirm
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { parseSearch } from '@/utils'

const { Column } = Table
const { Option } = Select
const FormItem = Form.Item
let pageSize = 10
let currentPage = 1

const SupplierMgt = (props) => {
  const { match, history } = props
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue } = props.form
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [count, setCount] = useState(0)
  const [fieldModal, setFieldModal] = useState(false)
  const [saveLoading, setSaveLoading] = useState(false)
  const [supplierOptions, setSupplierOptions] = useState([])
  const [projectOptions, setProjectOptions] = useState([])
  const [editId, setEditId] = useState('')
  const [keyword, setKeyword] = useState('')

  const search = parseSearch(props.location.search)

  useEffect(() => {
    currentPage = search.page ? +search.page : 1
    pageSize = search.limit ? +search.limit : 10
    getSupplierOptions()
    getProjectOptions()
    getList()
  }, [])

  const getList = txt => {
    setLoading(true)
    txt = txt === undefined ? keyword : txt
    const params = {
      limit: pageSize,
      page: currentPage
    }
    if (txt) {
      params.txt = txt
    }
    api.getSupplierMappingList(params).then(data => {
      setList(data.list)
      setCount(data.count)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const getSupplierOptions = () => {
    return api.getSysSupplierList({
      page: 1,
      limit: global.paramsLimit,
      isValidate: 1
    }).then(data => {
      setSupplierOptions(data.list || [])
    })
  }

  const getProjectOptions = () => {
    return api.getProjectOrProduct({
      open: 0,
      projectId: 0
    }).then(list => {
      setProjectOptions(list || [])
    })
  }

  const onChangeTable = (pagination, filters, sorter) => {
    currentPage = pagination.current
    pageSize = pagination.pageSize
    history.replace(match.path + '?page=' + currentPage + '&limit=' + pageSize)
    getList()
  }

  const onSearch = () => {
    currentPage = 1
    getList()
  }

  const onReset = () => {
    setKeyword('')
    currentPage = 1
    getList('')
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const addFields = () => {
    resetFields()
    setEditId('')
    setFieldModal(true)
  }

  const onEdit = (data) => {
    resetFields()
    setEditId(data.id)
    setFieldModal(true)
    setFieldsValue({
      supplierId: data.supplierId,
      projectIds: Array.isArray(data.projects) ? data.projects.map(item => item.id) : [],
      toSupplierId: data.toSupplierId
    })
  }

  const formSubmit = (e) => {
    e.preventDefault()
    validateFields((err, vals) => {
      if (!err) {
        if (editId) {
          vals.id = editId
        }
        setSaveLoading(true)
        api.saveMessageSupplierMappingSave(vals)
          .then(() => {
            setSaveLoading(false)
            setFieldModal(false)
            message.success('保存成功')
            getList()
          })
          .catch(() => setSaveLoading(false))
      }
    })
  }

  const onDelete = (data) => {
    api.deleteMessageSupplierMappingSave({ supplierId: data?.supplierId, toSupplierId: data?.toSupplierId }).then(() => {
      message.success('删除成功')
      getList()
    })
  }

  return (
    <>
      <div className="bulle-wrap">
        <div className="filter-item">
          <label htmlFor="">搜索：</label>
          <Input 
            placeholder="供应商/关联项目/供应商编码" 
            value={keyword}
            onChange={evt => setKeyword(evt.target.value.trim())}
            onPressEnter={onSearch} 
          />
        </div>
        <div className="bulle-wrap-btn">
          <BtnGroup cancelName="重置" confirmName="筛选" onCancel={onReset} onConfirm={onSearch} />
        </div>
      </div>
      <div className="line"></div>
      <div className="bulle-wrap-add">
        <Button type="primary" onClick={addFields}>金蝶供应商关联</Button>
      </div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey="id"
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        // scroll={{x: 1400}}
        onChange={onChangeTable}
      >
        <Column title="ID" dataIndex="id" />
        <Column title="订单供应商名称" dataIndex="supplierName" width={160} />
        <Column title="订单供应商编码" dataIndex="supplierCode" width={120} align='center' />
        <Column
          title="订单项目"
          dataIndex="projects"
          render={(projects) => {
            if (!Array.isArray(projects) || !projects.length) return '-'
            return projects.map(item => item.name).join('，')
          }}
        />
        <Column title="新供应商名称" dataIndex="toSupplierName" width={160} />
        <Column title="新供应商编码" dataIndex="toSupplierCode" width={120} align='center' />
        <Column title="修改人" dataIndex="updateName" width={120} />
        <Column title="修改时间" dataIndex="updateTime" width={200} />
        <Column title="操作" key="set" width={120} align='center' render={(text, record) => (
          <>
            <a onClick={() => onEdit(record)}>修改</a>
            {' '}
            <Popconfirm title="请确认是否删除？" cancelText="取消" okText="确认" onConfirm={() => onDelete(record)}>
              <a>删除</a>
            </Popconfirm>
          </>
        )} />
      </Table>
      <Modal
        title="金蝶供应商关联"
        visible={fieldModal}
        onOk={formSubmit}
        onCancel={() => { setFieldModal(false) }}
        destroyOnClose={true}
        confirmLoading={saveLoading}
        maskClosable={false}
      >
        <Form {...formItemLayout}>
          <FormItem label="订单供应商">
            {getFieldDecorator('supplierId', {
              rules: [{ required: true, message: '请选择订单供应商' }]
            })(
              <Select
                placeholder="请选择订单供应商"
                showSearch
                optionFilterProp="children"
                dropdownMatchSelectWidth={false}
              >
                {supplierOptions.map(item => (
                  <Option key={item.id} value={item.id}>{item.name}</Option>
                ))}
              </Select>
            )}
          </FormItem>
          <FormItem label="订单项目">
            {getFieldDecorator('projectIds', {
              rules: [{ required: true, message: '请选择订单项目' }]
            })(
              <Select
                mode="multiple"
                placeholder="请选择订单项目"
                showSearch
                optionFilterProp="children"
                dropdownMatchSelectWidth={false}
              >
                {projectOptions.map(item => (
                  <Option key={item.id} value={item.id}>{item.name}</Option>
                ))}
              </Select>
            )}
          </FormItem>
          <FormItem label="新供应商">
            {getFieldDecorator('toSupplierId', {
              rules: [{ required: true, message: '请选择新供应商' }]
            })(
              <Select
                placeholder="请选择新供应商"
                showSearch
                optionFilterProp="children"
                dropdownMatchSelectWidth={false}
              >
                {supplierOptions.map(item => (
                  <Option key={item.id} value={item.id}>{item.name}</Option>
                ))}
              </Select>
            )}
          </FormItem>
        </Form>
      </Modal>
    </>
  )
}

export default Form.create()(SupplierMgt)